import * as React from 'react'
import { FC, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { currencyString } from '@sales-center/common'
import { TotalAndDescription } from '../../../TotalAndDescription'
import { defaultFilters } from '@user/store/opportunity/filters'
import { IOption } from '@user/components/Filters'
import { useSaveOpportunityFilters } from '@user/store/opportunity/hooks'

interface Props {
  count: number
  value: number
  assignees?: IOption[]
  salesTeams?: IOption[]
  canViewOpps: boolean
}

export const Opportunities: FC<Props> = (props) => {
  const { count, value, assignees, salesTeams, canViewOpps } = props
  const navigate = useNavigate()

  const saveOpportunityFilters = useSaveOpportunityFilters()

  const callToAction = useCallback(() => {
    saveOpportunityFilters({
      ...defaultFilters,
      filters: {
        ...defaultFilters.filters,
        nextActionDate: {
          ...defaultFilters.filters.nextActionDate,
          value: {
            matchType: 'lt',
            start: new Date(),
            end: null,
          },
        },
        salesTeamIds: {
          ...defaultFilters.filters.salesTeamIds,
          value: { mode: 'any', options: salesTeams || [] },
        },
        assignee: {
          ...defaultFilters.filters.assignee,
          value: { mode: 'any', options: assignees || [] },
        },
      },
    })

    navigate('/opportunities')
  }, [assignees, navigate, salesTeams, saveOpportunityFilters])

  return (
    <TotalAndDescription
      testIdPrefix="overdue-next-action-dates-widget-opportunities-section"
      callToActionFunction={callToAction}
      callToActionText="Review"
      callToActionAllowed={canViewOpps}
      description={
        <>
          {count == 1 ? 'This Opportunity has' : 'These Opportunities have'} a
          total value of <b>{`$${currencyString(value)}`}</b>.
        </>
      }
      headerText={count == 1 ? 'Opportunity' : 'Opportunities'}
      total={count}
    />
  )
}

Opportunities.displayName = 'Opportunities'
